<template>
  <div class="categoricaldata">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ this.$t('categories-view.title') }}</p>
                  </header>
                </div>
                <div class="column is-narrow">
                  <b-button class="button" @click="backClicked" icon-left="arrow-left-bold">
                    {{ $t('common.back') }}
                  </b-button>
                </div>
              </div>
              <b-tabs class="categorical-data-tabs" type="is-toggle" expanded>
                <b-tab-item :label="$t('tasks-view.component-title')" icon="format-list-checks">
                  <TasksCategorical v-bind:categorical_data="this.categoricalData.tasks"
                                    @addCategoricalData="showAddNewPrompt" @updateCategoricalData="updateCategories"
                                    @deleteCategoricalData="showDeletePrompt"/>
                </b-tab-item>
                <b-tab-item :label="$t('personnel-view.component-title')" icon="account-hard-hat">
                  <PersonnelCategorical v-bind:categorical_data="this.categoricalData.personnel"
                                        @addCategoricalData="showAddNewPrompt" @updateCategoricalData="updateCategories"
                                        @deleteCategoricalData="showDeletePrompt"/>
                </b-tab-item>
                <b-tab-item :label="$t('equipments-view.component-title')" icon="robot-industrial">
                  <EquipmentsCategorical v-bind:categorical_data="this.categoricalData.equipments"
                                         @addCategoricalData="showAddNewPrompt"
                                         @updateCategoricalData="updateCategories"
                                         @deleteCategoricalData="showDeletePrompt"/>
                </b-tab-item>
                <b-tab-item :label="$t('consumables-view.component-title')" icon="cart-variant">
                  <ConsumablesCategorical v-bind:categorical_data="this.categoricalData.consumables"
                                          @addCategoricalData="showAddNewPrompt"
                                          @updateCategoricalData="updateCategories"
                                          @deleteCategoricalData="showDeletePrompt"/>
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";
import TasksCategorical from "@/components/TasksCategorical";
import PersonnelCategorical from "@/components/PersonnelCategorical";
import EquipmentsCategorical from "@/components/EquipmentsCategorical";
import ConsumablesCategorical from "@/components/ConsumablesCategorical";

export default {
  name: "CategoricalData",
  components: {TasksCategorical, PersonnelCategorical, EquipmentsCategorical, ConsumablesCategorical},
  data() {
    return {
      categoricalData: [],
      isLoading: false
    }
  },
  methods: {
    readCategoricalData: function () {
      this.isLoading = true
      this.categoricalData = []
      const functions = firebase.app().functions("europe-west3");
      const getProjectsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getProjectsFunction({action: "get_categories", collections: ["tasks", "personnel", "equipments", "consumables"]})
          .then((result) => {
            console.log("categories result: ", result.data);
            this.categoricalData = result.data
            this.isLoading = false
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting categories: ", error);
            this.isLoading = false;
          });
    },
    showAddNewPrompt: function (onConfirmBlock) {
      this.$buefy.dialog.prompt({
        inputAttrs: {
          placeholder: this.$t('categories-view.enter-name').toString(),
          type: 'text'
        },
        confirmText: this.$t('common.add').toString(),
        trapFocus: true,
        closeOnConfirm: true,
        onConfirm: onConfirmBlock
      })
    },
    updateCategories: function (payload) {
      this.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const updateCategoriesFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateCategoriesFunction({
        action: "update_category",
        collection: payload.collectionName,
        data: {
          [payload.dataFieldTitle]: payload.data
        }
      }).then((data) => {
        this.isLoading = false;
        const tempCategoricalData = JSON.parse(JSON.stringify(this.categoricalData));
        tempCategoricalData[payload.collectionName][payload.dataFieldTitle] = payload.data
        this.categoricalData = tempCategoricalData
        this.showSuccess(this.$t('messages.success'));
        console.log("updateCategories success", data)
      }).catch((error) => {
        this.isLoading = false;
        this.showError(error.message)
        console.log("Error updating task categories: ", error);
      });
    },
    showDeletePrompt: function (onConfirmBlock) {
      this.$buefy.dialog.confirm({
        title: this.$t('categories-view.delete-element-title').toString(),
        message: this.$t('categories-view.delete-element-message').toString(),
        confirmText: this.$t('categories-view.delete-element-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: onConfirmBlock
      });
    },
    /*
     UI Events
     */
    backClicked: function () {
      this.$router.back()
    }
  },
  mounted() {
    this.readCategoricalData();
  }
};
</script>

<style scoped>
.categorical-data-tabs {
  margin-top: 16px;
}
</style>
